import { useAppSelector } from "@/lib/store";
import type { organization_type } from "@/models/organization.model";

export const useActiveOrganizationType = (): organization_type | undefined =>
  useAppSelector((state) => state.organization.organizations.find((organization) => organization.id === state.organization.activeOrgId)?.type);
